import React, { Component } from 'react'
import { Link } from 'react-router'
import Helmet from 'react-helmet';
import MobileDetect from 'mobile-detect'
import 'whatwg-fetch'
import ReactGA from 'react-ga'

import './MandalaComponent.css'
import logo from './artbox-logo-horiz-small.png'
import logo2x from './artbox-logo-horiz-small@2x.png'
import logo3x from './artbox-logo-horiz-small@3x.png'

// import { TwitterButton, FacebookShareButton } from 'react-social-buttons'

class Mandala extends Component {

  constructor(props) {
    super(props)
    this.root = `mandala/${props.params.mandalaTitle}`
    this.state = { description: "", title: "" }
  }

  componentDidMount() {
    fetch(`${this.root}/description.txt`)
      .then( response => { return response.text() } )
      .then( body => {
        this.setState({ description: body })
      } )
      fetch(`${this.root}/meta.json`)
      .then( response => { return response.json() } )
      .then( json => {
        this.setState(json)
      } )
  }

  render() {

    const root = `mandala/${this.props.params.mandalaTitle}`

    const htmlAttributes = {"prefix": "og: http://ogp.me/ns#"}
    var meta = [
      {"property": "og:type", "content": "article"}
    ];
  const mandala = {
    title: this.props.params.mandalaTitle,
    description: "マンダラの Description",
    imageUrl: `${root}/${this.props.params.mandalaTitle}.png`,
    downloadUrl: `${root}/${this.props.params.mandalaTitle}.mandala`
  };
    if (mandala) {
      meta.push({"property": "og:title", "content": this.state.title});
      meta.push({"property": "og:description", "content": mandala.description});
      meta.push({"property": "og:image", "content": mandala.imageUrl});
      meta.push({"property": "twitter:card", "content": "summary_large_image"});
      meta.push({"property": "twitter:title", "content": mandala.title});
      meta.push({"property": "twitter:description", "content": mandala.description});
      meta.push({"property": "twitter:image", "content": mandala.imageUrl});
    }

    return (
      <div className="Mandala-container">
      <div className="Mandala-content">
      <Helmet
      htmlAttributes={htmlAttributes}
      title={`ART BOX: ${this.state.title}`}
      meta={meta}
      />

      <h1><Link to="/"><img src={logo} srcSet={`${logo2x} 2x, ${logo3x} 3x`} alt="ART BOX ロゴ" /></Link></h1>
      <h2 className="Mandala-title">{this.state.title}</h2>
      <div className="Mandala-image-container"><img className="Mandala-image" src={mandala.imageUrl} alt="マンダラの画像"/></div>
      <p>{this.state.description}</p>
      <p><a className="Mandala-download" href={mandala.downloadUrl} onClick={ ReactGA.event( { category: "Mandala", action: "download", label: this.state.title } ) } >ダウンロード</a></p>
      {this._renderHint()}
      {/*<div><FacebookShareButton url={url} /><TwitterButton url={url} text="this page is cool"/></div>*/}
      </div>
      </div>
    )
  }

  _renderHint() {
    const device = new MobileDetect(window.navigator.userAgent)
    if (device.os() === 'iOS') {
      return (
        <div className="hint">
        <p>ダウンロードできないときは Safari で開いてください</p>
        </div>
      )
    } else {
      return (
        <div className="hint">
        <p>ダウンロードしたファイルは iPhone や iPad にインストールした <a href="http://appstore.com/hiroartdirectionsinc/mandalart">MandalArt</a> や <a href="http://appstore.com/hiroartdirectionsinc/lifeart">LifeArt</a> で開くことができます。</p>
        <p>iPhone や iPad にファイルを送るには、メールや <a href="https://support.apple.com/ja-jp/HT203106">AirDrop</a> をお使いください。</p>
        </div>
      )
    }
  }
}

export default Mandala



/** WEBPACK FOOTER **
 ** ./src/components/MandalaComponent.js
 **/